// test1263
(1263 && 0);
